export interface IonButtonInterface {
  text: string;
  role: string;
  handler?: () => void;
}
